import React, { useState } from "react";
import {
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Box,
    Avatar,
    Menu,
    MenuItem,
    Drawer,
    Divider,
    useMediaQuery
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";

import { useTheme } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import logo from "../../assets/logoWhite.svg";
import profileLogo from "../../assets/profileWhite.svg";

import { logout } from "../../config/auth/userSlice";
import useCheckAuthToken from "../../Hooks/useCheckAuthToken";
import { generateMenuByAccess } from "../../Utils/menuBuilder";

import { LinksGroup } from "./LinksGroup";
import { NavLinksGroup } from "./NavLinksGroup";

const NavBar: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

    const [drawerOpen, setDrawerOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [openedGroup, setOpenedGroup] = useState<string | null>(null);

    const user = useSelector((state: any) => state.user.user);
    const isAuthenticated = useCheckAuthToken();

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const groupedRoutes = generateMenuByAccess(user?.scope, user?.category);

    const handleToggle = (group: string) => {
        setOpenedGroup((prev) => (prev === group ? null : group));
    };

    const handleDrawerToggle = () => {
        setDrawerOpen(!drawerOpen);
    };

    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleLogOut = () => {
        dispatch(logout());
        navigate("/login");
    };

    const links = Object.entries(groupedRoutes).map(([groupLabel, items]) => (
        <LinksGroup
            key={groupLabel}
            label={groupLabel}
            icon={items[0]?.icon}
            links={items}
            access={user?.scope}
            category={user?.category}
            accessCategory={user?.category}
        />
    ));

    const menuItems = Object.entries(groupedRoutes).map(([groupLabel, items]) => (
        <NavLinksGroup
            key={groupLabel}
            label={groupLabel}
            icon={items[0]?.icon}
            links={items}
            opened={openedGroup === groupLabel}
            onToggle={() => handleToggle(groupLabel)}
            access={user?.scope}
            category={user?.category}
            accessCategory={user?.category}
        />
    ));

    return (
        <>
            {/* 🔷 TOP BAR */}
            <AppBar sx={{ backgroundColor: "#036a85", top: 0, position: "static", zIndex: theme.zIndex.drawer + 1 }}>

            </AppBar>
        </>
    );
};

export default NavBar;